export function addCssToHead(css) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
}

export function hexToRGB(hex, a = 255) {
    // Remove any leading '#' symbol
    hex = hex.replace(/^#/, '');

    // If shorthand notation, convert to full form, e.g., "f0a" -> "ff00aa"
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Parse the hex string into its numeric value
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Return the formatted RGB string
    return a == undefined || a == 1 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${a})`;
}


export function getSoftColor(hex, percentage) {
    // Remove any leading '#' symbol.
    hex = hex.replace(/^#/, '');

    // If the hex is in 3-digit format, convert it to 6-digit.
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Parse the r, g, b values from the hex string.
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Blend each component with white (255, 255, 255)
    // New value = original value + (255 - original value) * percentage
    r = Math.round(r + (255 - r) * percentage);
    g = Math.round(g + (255 - g) * percentage);
    b = Math.round(b + (255 - b) * percentage);

    // Convert the new RGB values back to a hex string.
    const toHex = (value) => value.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
